
import { defineComponent } from 'vue'

export default defineComponent({
  name: 'RegisterFlow',
  props: {
    steps: {
      type: Number,
      default: 1,
    },
    nowStep: {
      type: Number,
      default: 1,
      required: true,
    },
  },
})
